/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeSources200ResponseData
 */
export interface MergeSources200ResponseData {
    /**
     * The ID of the surviving source
     * @type {string}
     * @memberof MergeSources200ResponseData
     */
    source_to_keep_id: string;
    /**
     * Number of referrals repointed at the surviving source
     * @type {number}
     * @memberof MergeSources200ResponseData
     */
    leads_moved_count: number;
}

/**
 * Check if a given object implements the MergeSources200ResponseData interface.
 */
export function instanceOfMergeSources200ResponseData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source_to_keep_id" in value;
    isInstance = isInstance && "leads_moved_count" in value;

    return isInstance;
}

export function MergeSources200ResponseDataFromJSON(json: any): MergeSources200ResponseData {
    return MergeSources200ResponseDataFromJSONTyped(json, false);
}

export function MergeSources200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeSources200ResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source_to_keep_id': json['source_to_keep_id'],
        'leads_moved_count': json['leads_moved_count'],
    };
}

export function MergeSources200ResponseDataToJSON(value?: MergeSources200ResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_to_keep_id': value.source_to_keep_id,
        'leads_moved_count': value.leads_moved_count,
    };
}

